import React, { Suspense } from 'react'

import StyledAdminWrapper from './StyledAdminWrapper'
import EngagementEntry from 'components_v2/Admin/Engagement/EngagementEntry'

const EngagementWrapper = () => (
  <StyledAdminWrapper>
    <Suspense fallback=''>
      <EngagementEntry />
    </Suspense>
  </StyledAdminWrapper>
)

export default EngagementWrapper
